import { AfterViewInit, Component, inject, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import {
  JeevesCustomerActionConfigService,
  JeevesCustomerDeliveryLocationListConfigService,
  JeevesCustomerDetailsComponent,
  JeevesDeliveryAddressesService
} from 'gung-standard-jeeves';
import {
  AuthService,
  CustomerDetailsConfigService,
  CustomerService,
  FeatureActivatedGuardWrapper,
  LocationConfigService,
  NavbarConfigService,
  NavigationConfig,
  RouterEventsService
} from 'gung-standard';
import { GungTabChangeEvent } from 'gung-common';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
  selector: 'otto-olsen-customer-details',
  templateUrl: './otto-olsen-customer-details.component.html',
  styleUrls: ['./otto-olsen-customer-details.component.scss'],
  standalone: false
})
export class OttoOlsenCustomerDetailsComponent extends JeevesCustomerDetailsComponent implements OnInit {

  protected router = inject(Router);
  protected titleService = inject(Title);
  protected translateService = inject(TranslateService);
  pageTitle = '';
  isSalesOrAdmin: boolean = false;



  constructor(
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(environment);
    if (this.route.snapshot.queryParams.tab) {
      this.activeIdString = this.route.snapshot.queryParams.tab;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSalesOrAdmin = roles.findIndex(r => r === 'ADMIN') > -1 || roles.findIndex(r => r === 'SALES') > -1;
      });
  }

  tabChanged(event: GungTabChangeEvent) {
    this.router.navigate([], {
      queryParams: {
        tab: event.nextId
      },
      queryParamsHandling: 'merge'
    });

    if (event.nextId === 'orders') {
      this.pageTitle = this.translateService.instant('OTTO_OLSEN_ORDER_OVERVIEW');
      this.titleService.setTitle(this.pageTitle);
    } else {
      this.titleService.setTitle('Otto Olsen B2B');
    }
  }
}
